import ShowIf from "../../ShowIf/ShowIfView";
import styles from "./Block.module.scss";
import i18n from "../../../constants/i18n";
import React from "react";
import * as PropTypes from "prop-types";

export const PhotoBackground = ({
    url,
    extraClassName,
    mediaPlaceholder,
    alternativePlaceholderImage,
    showBlockPhotoUploadModal,
    allowPhotoUpload,
}) => {
    const alternativePlaceholderUrl = alternativePlaceholderImage
        ? alternativePlaceholderImage.fileName
        : null;

    return (
        <>
            <ShowIf condition={!url}>
                <div className={`${styles.photoLoader} ${extraClassName}`}>
                    <div className="loader"></div>
                </div>
            </ShowIf>
            {/* If a ceremony main image is chosen, then show this image as alternative placeholder. */}
            <ShowIf
                condition={
                    url && url === mediaPlaceholder && alternativePlaceholderUrl
                }
            >
                <div
                    className={`${styles.mediaObject} ${extraClassName} ${
                        allowPhotoUpload ? styles.pointCursor : ""
                    }`}
                    style={{
                        backgroundImage: `url(${alternativePlaceholderUrl})`,
                    }}
                    onClick={() => {
                        if (allowPhotoUpload) {
                            showBlockPhotoUploadModal();
                        }
                    }}
                >
                    <div className={`${styles.mainImageLabel}`}>
                        <span title={i18n.generic.noImageSelectedWarning}>
                            {i18n.generic.mainImage}
                        </span>
                    </div>
                </div>
            </ShowIf>
            {/* Default placeholder if NO ceremony main image is chosen. */}
            <ShowIf
                condition={
                    url &&
                    url === mediaPlaceholder &&
                    !alternativePlaceholderUrl
                }
            >
                <div
                    className={`${styles.mediaObject} ${extraClassName} ${
                        allowPhotoUpload ? styles.pointCursor : ""
                    }`}
                    style={{ backgroundImage: `url(${url})` }}
                    onClick={() => {
                        if (allowPhotoUpload) {
                            showBlockPhotoUploadModal();
                        }
                    }}
                />
            </ShowIf>
            {/* Chosen image. */}
            <ShowIf condition={url && url !== mediaPlaceholder}>
                <div
                    className={`${styles.mediaObject} ${extraClassName} ${
                        allowPhotoUpload ? styles.pointCursor : ""
                    }`}
                    style={{ backgroundImage: `url(${url})` }}
                    onClick={() => {
                        if (allowPhotoUpload) {
                            showBlockPhotoUploadModal();
                        }
                    }}
                />
            </ShowIf>
        </>
    );
};

PhotoBackground.propTypes = {
    url: PropTypes.any,
    extraClassName: PropTypes.any,
    showBlockPhotoUploadModal: PropTypes.func,
    allowPhotoUpload: PropTypes.bool,
};
